export const novelErrorsEn = {
  unknown: 'Unclassified error',
  codes: {
    BAD_REQUEST: 'The server rejected the request as invalid.',
    VALIDATION_ERROR: 'The server rejected the request as invalid.',
    UNAUTHORIZED: 'Your sign-in has expired. Sign in again.',
    FORBIDDEN: 'This account is not allowed to do that.',
    NOT_FOUND: 'It no longer exists.',
    CONFLICT: 'The data changed in the meantime. Refresh and try again.',
    NOVEL_RELEASE_NOT_CONFIGURED: 'The production release target is not configured on Stage.',
    NOVEL_RELEASE_TARGET_UNREACHABLE: 'Stage could not reach production. See the release record below for details.',
    NOVEL_RELEASE_TARGET_REJECTED: 'Production rejected the release. See the release record below for the reason.',
    NOVEL_RELEASE_FAILED: 'Production could not apply the release. The cause is in the record details.',
    NOVEL_RELEASE_STORAGE_RESIDUE: 'The content still references storage addresses that cannot be rewritten (old OSS domain, http or query strings). Fix the image addresses in Studio, cut a new version and release again.',
    NOVEL_RELEASE_STALE: 'The release stalled (the API restarted mid-release) and an admin finished it as failed.',
    NOVEL_RELEASE_IN_PROGRESS: 'Production is still applying this release. The record stays in progress and updates once the receipt settles; refresh later.',
    NOVEL_RELEASE_ALREADY_FAILED: 'This release ID has already failed. Start a new release.',
    NOVEL_RELEASE_CHECKSUM_MISMATCH: 'Production found that the release bundle checksum does not match.',
    NOVEL_RELEASE_BUNDLE_INVALID: 'Production found that the object list of the release bundle does not match the content.',
    RATE_LIMITED: 'Too many requests. Try again shortly.',
    INTERNAL_ERROR: 'Server error. Try again later.',
    HTTP_ERROR: 'The request failed.',
  },
  reasons: {
    release_in_progress: 'This work already has a release in progress. Wait for it to finish.',
    release_id_conflict: 'This release ID already belongs to different content.',
    release_slug_taken: 'Main already has a work with this slug that a Main creator made, so a release cannot overwrite it.',
    release_version_conflict: 'Main already has this version number with different content. Cut a new version in Studio and release that one.',
    release_content_invalid: 'This version does not pass the content check on Main, so Main did not apply it.',
    release_pack_archived: 'The work on Main is archived, so it cannot be released to.',
    release_not_stale: 'This release is still moving. Only releases stalled for over 30 minutes can be finished.',
    release_invalid_transition: 'This release record has already ended. Refresh to see its status.',
    release_not_found: 'This release record no longer exists.',
    pack_not_found: 'This work no longer exists.',
    pack_content_invalid: 'The content does not pass the check, so the work cannot be published.',
    invalid_status_transition: 'The current status of this work does not allow this action. Refresh and try again.',
    invalid_featured_rank: 'Featured order must be a whole number, 0 or greater.',
    run_not_found: 'This run no longer exists.',
    run_archived: 'This run is archived, so its jobs cannot be retried.',
    adopt_forbidden: 'Only the owner of the source run can adopt a side.',
    stale_comparison: 'The source run has moved on since the comparison started. Restart the comparison.',
    already_adopted: 'A side of this comparison has already been adopted.',
    nothing_to_adopt: 'This side has no new turns to adopt yet.',
    comparison_not_found: 'This comparison no longer exists. Comparisons are cleaned up after 24 hours.',
    invalid_comparison_source: 'A comparison run cannot be the source of another comparison.',
    model_not_configured: 'The selected writing model is not configured.',
    invalid_performer: 'The selected model is not on the writing chain.',
    invalid_director_comparison: 'A director on/off comparison needs the same model on both sides.',
    narrative_required: 'This work has no story content, so it cannot be compared.',
    busy: 'The run is generating right now. Try again when it finishes.',
  },
}

export const novelErrorsZh = {
  unknown: '未归类错误',
  codes: {
    BAD_REQUEST: '服务端认为请求不合法，已拒绝。',
    VALIDATION_ERROR: '服务端认为请求不合法，已拒绝。',
    UNAUTHORIZED: '登录已过期，请重新登录。',
    FORBIDDEN: '当前账号没有这项操作的权限。',
    NOT_FOUND: '要操作的对象已不存在。',
    CONFLICT: '数据已被改动，请刷新后再试。',
    NOVEL_RELEASE_NOT_CONFIGURED: 'Stage 尚未配置正式环境发布目标。',
    NOVEL_RELEASE_TARGET_UNREACHABLE: 'Stage 连不上正式环境，详见下方发布记录。',
    NOVEL_RELEASE_TARGET_REJECTED: '正式环境拒收了这次发布，原因见下方发布记录。',
    NOVEL_RELEASE_FAILED: '正式环境没能套用这次发布，原因见记录详情。',
    NOVEL_RELEASE_STORAGE_RESIDUE: '内容里还有改写不了的存储地址（旧 OSS 域名、http 或带查询串的地址）。请在创作台改好图片地址、切新版本后再发布。',
    NOVEL_RELEASE_STALE: '这次发布卡住了（API 在发布中重启），已由管理员收尾为失败。',
    NOVEL_RELEASE_IN_PROGRESS: '正式环境仍在处理这次发布，记录保持进行中，回执落定后自动更新，请稍后刷新。',
    NOVEL_RELEASE_ALREADY_FAILED: '这个发布编号此前已失败，请重新发起发布。',
    NOVEL_RELEASE_CHECKSUM_MISMATCH: '正式环境核对发布包 checksum 不一致。',
    NOVEL_RELEASE_BUNDLE_INVALID: '正式环境核对发现发布包的对象清单与内容不一致。',
    RATE_LIMITED: '请求太频繁，请稍后再试。',
    INTERNAL_ERROR: '服务端出错，请稍后再试。',
    HTTP_ERROR: '请求失败。',
  },
  reasons: {
    release_in_progress: '这部作品已有进行中的发布，请等它结束。',
    release_id_conflict: '这个发布编号已对应其他内容。',
    release_slug_taken: 'Main 上已有同短链名、由 Main 创作者自己创建的作品，发布不能覆盖它。',
    release_version_conflict: 'Main 上已有同版本号但内容不同的版本。请在创作台切出新版本再发布。',
    release_content_invalid: '这个版本按 Main 的当前规则校验不通过，Main 没有套用。',
    release_pack_archived: 'Main 上的这部作品已归档，不能再发布到它。',
    release_not_stale: '这次发布还在推进，只有超过 30 分钟没推进的发布才能收尾。',
    release_invalid_transition: '这条发布记录已经结束，请刷新查看状态。',
    release_not_found: '这条发布记录已不存在。',
    pack_not_found: '这部作品已不存在。',
    pack_content_invalid: '作品内容未通过校验，不能上架。',
    invalid_status_transition: '作品当前状态不允许这个操作，请刷新后再试。',
    invalid_featured_rank: '精选序必须是 0 或更大的整数。',
    run_not_found: '这局对局已不存在。',
    run_archived: '对局已归档，不能重试任务。',
    adopt_forbidden: '只有源对局的属主本人能采纳。',
    stale_comparison: '源对局在对比开始后有了新进度，请重新开始对比。',
    already_adopted: '这次对比已经采纳过一边。',
    nothing_to_adopt: '这一边还没有可采纳的新回合。',
    comparison_not_found: '这次对比已不存在（对比 24 小时后自动清理）。',
    invalid_comparison_source: '对比对局不能再作为对比的来源。',
    model_not_configured: '所选写作模型未配置。',
    invalid_performer: '所选模型不在写作链上。',
    invalid_director_comparison: '只比导演开/关时，两边必须是同一个模型。',
    narrative_required: '作品没有正文，不能对比。',
    busy: '对局正在生成，请等它结束再试。',
  },
}
